import React from "react";

const CfIcon: React.FC = () => {
  return (
    <img
      src="https://codeforces.org/s/172836784932837/favicon-32x32.png"
      alt="CF icon"
    />
  );
};

export default CfIcon;
